// removed by extract-text-webpack-plugin
module.exports = {"modal":"modal-3fwD_","content":"content-28WO9","main":"main-2gXcn","header":"header-3_9xS","headerText":"headerText-13P6z","footer":"footer-3vQTN","overlay":"overlay-3JhDf","none":"none-1i0VE","closeIcon":"closeIcon-2ebis","eas-icon":"eas-icon-2XNaN","easIcon":"eas-icon-2XNaN","modal-footer-action":"modal-footer-action-3OdFJ","modalFooterAction":"modal-footer-action-3OdFJ"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/dialogs/dialog/dialog.less
 ** module id = 158
 ** module chunks = 0
 **/